import InvoiceDetails from "@/components/InvoiceDetails";
import UpdateManagerApprover from "@/components/dialog/UpdateManagerApprover";
import UpdateSecondaryManagerApprover from "@/components/dialog/UpdateSecondaryManagerApprover";
import InvoiceSkeleton from "@/components/skeleton/InvoiceSkeleton";
import { STALE_TIME_INVOICE } from "@/constants";
import { UserContext } from "@/context/User/UserContext";
import { getSingleMasterInvoice, Invoice } from "@/services/invoice-functions";
import { useContext } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

const AdminManage = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const invoice = useQuery({
		queryKey: ["invoice", id],
		queryFn: () => getSingleMasterInvoice(user?.accessToken!, id),
		enabled: !!user?.accessToken,
		staleTime: STALE_TIME_INVOICE,
		onSuccess: (data) => {
			console.log(data);
		},
	});

	const canUpdateManagerApprover = (invoice: Invoice) => {
		if (invoice.managerapproved) return false;
		if (invoice.manageramend) return false;
		if (invoice.managerrejected) return false;
		return true;
	};

	const canUpdateSecondaryManagerApprover = (invoice: Invoice) => {
		if (!invoice.managersecondapprovalrequired) return false;
		if (!invoice.secondarymanagerapproved) return true;
		return false;
	};

	return (
		<div>
			{invoice.isLoading ? (
				<InvoiceSkeleton />
			) : invoice.isError ? (
				<div className="align-centre">
					<h5 className="text-center">Error loading claim.</h5>
				</div>
			) : (
				invoice.data && (
					<>
						<div className="flex gap-3 items-end justify-between">
							<h1 className="font-medium text-4xl">
								CLAIM NO: {invoice.data.invoicemasterid}
							</h1>
							{canUpdateManagerApprover(invoice.data) ? (
								<UpdateManagerApprover
									accessToken={user?.accessToken!}
									invoiceId={invoice.data.invoicemasterid}
									managerId={invoice.data.managerapprover}
								/>
							) : null}
							{canUpdateSecondaryManagerApprover(invoice.data) ? (
								<UpdateSecondaryManagerApprover
									accessToken={user?.accessToken!}
									invoiceId={invoice.data.invoicemasterid}
									managerId={invoice.data.secondarymanagertobeapprovedby!}
								/>
							) : null}
						</div>
						<InvoiceDetails invoice={invoice.data} accessToken={user?.accessToken!} />
					</>
				)
			)}
		</div>
	);
};

export default AdminManage;
